/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { call, put, takeLatest } from 'redux-saga/effects';

import { PROXY_READY } from '@nebula/airglow-plugin-unified-shell/dist/actions';

import { getFeatureFlags } from './feature.flags.saga';
import { statefulInit } from '../../common/actions';

export function* handleReady() {
  yield call(getFeatureFlags);
  yield put(statefulInit());
}

export default function* proxyReadySaga() {
  yield takeLatest(PROXY_READY, handleReady);
}
